import { snakeCase, toUpper } from 'lodash';
import { createSelector } from 'reselect';
import { UserFund } from 'src/types';
import {
  formatUnixDate,
  getMonthName,
  ordinal,
} from 'src/utils/dates/date-utility';
import { currency } from 'src/utils/utils';
import { getBankDetailsInArray } from '../sellTransaction/sellTransaction.selectors';
import { getSelectedFunds } from '../shoppingCart/shoppingCart.selectors';

export interface SubInfo {
  name: string;
  value: string;
  nameBold: boolean;
  valueBold: boolean;
}

function fundTransactionConfirmationDetails(funds: UserFund[]) {
  return funds?.map((fund) => {
    const {
      agreementNumber,
      agreementType,
      displayClassification,
      formattedEntityNames,
      fundName,
      productType,
      currentYearAmount,
      ticker,
      transferMonths = [],
      transferDays = [],
    } = fund;

    const frequencyText =
      '    Every ' +
      (transferMonths.length === 12
        ? 'month '
        : transferMonths
            .sort((a, b) => a.value - b.value)
            .map(
              (month, index) =>
                (index > 0 && index < transferMonths.length - 1
                  ? ', '
                  : index === transferMonths.length - 1 && index > 0
                  ? ' & '
                  : '') + getMonthName(month.label)
            )
            .join('')) +
      ' on the ' +
      transferDays
        ?.sort((a, b) => a.value - b.value)
        .map(
          (day, index) =>
            (index > 0 && index < transferDays.length - 1
              ? ', '
              : index === transferDays.length - 1 && index > 0
              ? ' & '
              : '') + ordinal(day.value)
        )
        .join('');

    const subInfo: SubInfo[] = [];
    if (fund.startDate) {
      subInfo.push({
        name: 'Est. Start Date',
        value: `${fund.startDate}`,
        nameBold: true,
        valueBold: false,
      });
    }
    subInfo.push({
      name: 'Frequency',
      value: `${frequencyText}`,
      nameBold: true,
      valueBold: false,
    });

    return {
      accountType: `${displayClassification} / ${agreementType}`,
      fundName,
      ticker,
      accountNumber: agreementNumber,
      registrations: formattedEntityNames,
      productType: toUpper(snakeCase(productType)),
      subInfo: subInfo,
      amount: currency(currentYearAmount),
    };
  });
}

export const getExecuteRecurringPurchase = (state) =>
  state.executeRecurringPurchase;

export const getRecurringPrintData = createSelector(
  [getSelectedFunds, getBankDetailsInArray],
  (selectedFundsList: UserFund[], bankDetailsInArray) => {
    const bankTransactionLine = [
      {
        deliveryMethodName: 'Direct Deposit',
        deliveryMethodLines: bankDetailsInArray,
        transactionLines: fundTransactionConfirmationDetails(selectedFundsList),
      },
    ];

    return {
      transactionType: 'AUTOMATICINVESTMENT',
      submittedDate: formatUnixDate(new Date()),
      deliveryMethodData: bankTransactionLine,
    };
  }
);
